export class PicturePdfRequest {
  constructor(public fileId: number, public fileName: string) {
  }
}
